export default __webpack_public_path__ + "static/media/report.c78acb0f.svg";